"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatCard = exports.StatDiff = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const design_system_1 = require("@servicetitan/design-system");
const Styles = __importStar(require("./stat-card.module.less"));
const formatters_1 = require("../../utils/formatters");
const calculateDiff = (value, prev, percents) => {
    const diff = (value - prev) * (percents ? 100 : 1);
    const absDiff = Math.abs(diff);
    const diffPercent = percents ? diff : prev && absDiff ? (100 * absDiff) / prev : 0;
    return [absDiff, diffPercent, diff >= 0];
};
const formatDifference = (value, isPlus, format) => {
    return (isPlus ? '+' : '-') + formatters_1.formatValue(value, format);
};
const formatDifferencePercentage = (value, isPlus) => {
    if (!value) {
        return '';
    }
    return (isPlus ? '+' : '-') + formatters_1.formatValue(value, 'percent-100');
};
const StatDiff = ({ value, prev, size, format, inverted, neutral, className, }) => {
    const percents = format === 'percent';
    const [absDiff, diffPercent, isIncrease] = calculateDiff(value !== null && value !== void 0 ? value : 0, prev !== null && prev !== void 0 ? prev : 0, percents);
    const diff = absDiff === 0 ? '' : isIncrease ? '▲ ' : '▼ ';
    let text = '';
    if (percents) {
        text += formatDifferencePercentage(absDiff, isIncrease);
    }
    else {
        text += formatDifference(absDiff, isIncrease, format);
        if (diffPercent !== 0) {
            text += ` (${formatDifferencePercentage(diffPercent, isIncrease)})`;
        }
    }
    return (jsx_runtime_1.jsxs(design_system_1.BodyText, Object.assign({ className: classnames_1.default(Styles.statDiff, {
            'c-red-500': !neutral && (inverted ? isIncrease : !isIncrease),
            'c-green-500': !neutral && (inverted ? !isIncrease : isIncrease),
            'c-neutral-200': !!neutral,
        }, className), size: size !== null && size !== void 0 ? size : 'small' }, { children: [jsx_runtime_1.jsx("span", { children: diff }, void 0), value === undefined ? '\u00A0' : text] }), void 0));
};
exports.StatDiff = StatDiff;
const StatCard = ({ title, description, value, percent, money, rate, prev, clean, inverted, neutral, fill, valueOnly, className, }) => {
    const format = money ? 'money' : percent ? 'percent' : rate ? 'rate' : 'number';
    const val = value === undefined ? '\u00A0' : formatters_1.formatValue(value, format);
    const eyebrow = jsx_runtime_1.jsx(design_system_1.Eyebrow, Object.assign({ className: classnames_1.default(Styles.title, 'ta-center') }, { children: title }), void 0);
    return (jsx_runtime_1.jsxs(design_system_1.Stack, Object.assign({ direction: "column", alignItems: "center", className: classnames_1.default('p-y-3', {
            'bg-white border-radius-2 border': !clean,
            'flex-grow-1 flex-basis-0': fill,
        }, className) }, { children: [description ? jsx_runtime_1.jsx(design_system_1.Tooltip, Object.assign({ text: description }, { children: eyebrow }), void 0) : eyebrow, jsx_runtime_1.jsx(design_system_1.BodyText, Object.assign({ className: "fs-6-i ff-display" }, { children: val }), void 0), !valueOnly && (jsx_runtime_1.jsx(exports.StatDiff, { value: value, prev: prev, format: format, inverted: inverted, neutral: neutral }, void 0))] }), void 0));
};
exports.StatCard = StatCard;
//# sourceMappingURL=stat-card.js.map